import { call, put, delay } from 'redux-saga/effects'
import _ from 'lodash'
import toast from 'react-hot-toast'

import api from 'Src/api'

import { fetchGuidesSuccess, fetchSpecificGuideSuccess } from 'Actions/guides'

const LIST_GUIDES_URL = 'v1/guides'
const DELETE_GUIDE_URL = 'v1/guides/:guide_id'
const FETCH_SPECIFIC_GUIDE_URL = 'v1/guides/:guide_id'

export const fetchGuides = function* ({ payload }) {
  let guideParams = {}
  if (payload) {
    guideParams = _.pick(payload, ['offset', 'limit', 'search'])
  }

  try {
    const response = yield call(api.get, LIST_GUIDES_URL, {
      params: guideParams
    })
    const { results, meta } = response.data
    yield put(fetchGuidesSuccess({ guides: results, totalCount: meta.total }))
  } catch (error) {
    console.error('Unable to fetch guides', error)
  }
}

export const deleteGuide = function* (guideId) {
  try {
    yield call(api.delete, DELETE_GUIDE_URL, {
      urlParams: {
        guide_id: guideId
      }
    })
    yield delay(100)
    yield call(fetchGuides, {})
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message)
    } else {
      toast.error('Unable to delete guide. Try again...')
    }
    console.error('Unable to delete guide', error)
  }
}

export const fetchSpecificGuide = function* ({ payload }) {
  const { guideId } = payload
  try {
    const response = yield call(api.get, FETCH_SPECIFIC_GUIDE_URL, {
      urlParams: {
        guide_id: guideId
      }
    })
    const guide = response.data
    yield put(fetchSpecificGuideSuccess({ guide }))
  } catch (error) {
    console.error('Unable to fetch specific guide', error)
  }
}
